import { render, staticRenderFns } from "./DraggableListAssets.vue?vue&type=template&id=2dbcfdf5"
import script from "./DraggableListAssets.vue?vue&type=script&lang=js"
export * from "./DraggableListAssets.vue?vue&type=script&lang=js"
import style0 from "./DraggableListAssets.vue?vue&type=style&index=0&id=2dbcfdf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports